namespace $ {
	export class $shm_hitalama_chat_message extends $giper_baza_entity.with({

		Author: $giper_baza_atom_text,
		Text: $giper_baza_text,
		Time: $giper_baza_atom_real,

	}){
		
		text( next?: string ) {
			return this.Text(next)?.value(next) ?? ''
		}
		
		author( next?: string ) {
			return this.Author(next)?.val(next) ?? ''
		}
		
		time( next?: number ) {
			return this.Time(next)?.val(next) ?? ''
		}

	}
}
